(function () {
  'use strict';
  try {
    var conn = navigator.connection || {};
    if (conn.saveData) return;
    if (/(^|\b)(slow-2g|2g|3g)$/.test(conn.effectiveType || '')) return;

    var EXCLUDE = /\/(cart|checkout|account|challenge|apps|admin|orders|localization)(\/|$|\?)/i;
    var INCLUDE = /^\/(products|collections|pages|blogs)\//i;
    var seen = {};
    var inflight = 0;
    var MAX = 3;
    var origin = location.origin;

    function eligible(href) {
      if (!href) return false;
      var u;
      try { u = new URL(href, origin); } catch (e) { return false; }
      if (u.origin !== origin) return false;
      if (u.pathname === location.pathname) return false;
      if (EXCLUDE.test(u.pathname)) return false;
      // chemins localisés /fr-fr/… /en-gb/… → tester le segment après le préfixe éventuel
      var p = u.pathname.replace(/^\/[a-z]{2}-[a-z]{2}(?=\/)/i, '');
      if (!INCLUDE.test(p) && !INCLUDE.test(u.pathname)) return false;
      var key = u.origin + u.pathname;
      if (seen[key]) return false;
      return key;
    }

    // 1) Speculation Rules (Chromium) — prefetch document, eagerness modérée (survol/proximité)
    var specSupported = HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules');
    if (specSupported) {
      var rules = {
        prefetch: [{
          source: 'document',
          where: { and: [
            { href_matches: '/*' },
            { not: { href_matches: '/cart*' } },
            { not: { href_matches: '/checkout*' } },
            { not: { href_matches: '/account*' } },
            { not: { href_matches: '/*/cart*' } },
            { not: { href_matches: '/*/checkout*' } },
            { not: { href_matches: '/*/account*' } },
            { not: { selector_matches: '[data-no-prefetch]' } }
          ] },
          eagerness: 'moderate'
        }]
      };
      var s = document.createElement('script');
      s.type = 'speculationrules';
      s.textContent = JSON.stringify(rules);
      document.head.appendChild(s);
    }

    // 2) Repli universel (Safari/iPhone inclus) : prefetch <link> au survol / 1er contact tactile.
    function doPrefetch(key, href) {
      if (seen[key] || inflight >= MAX) return;
      seen[key] = 1; inflight++;
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.as = 'document';
      l.href = href;
      l.onload = l.onerror = function () { inflight = Math.max(0, inflight - 1); };
      document.head.appendChild(l);
    }
    function fromEvent(e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || a.hasAttribute('data-no-prefetch') || a.target === '_blank') return;
      var key = eligible(a.getAttribute('href'));
      if (key) doPrefetch(key, a.href);
    }
    // pointerenter (souris) + touchstart (mobile) — passifs, délégués
    var hoverTimer;
    document.addEventListener('pointerover', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { fromEvent(e); }, 65); // intention = survol > 65 ms
    }, { passive: true });
    document.addEventListener('touchstart', fromEvent, { passive: true });
  } catch(e){window.LE&&LE(e)}
})();
